export default {
    unlockLevel: {
        visible: false,
        lesson_id: null,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/popup/state.js